import { render, staticRenderFns } from "./fullchat.vue?vue&type=template&id=d9295620&scoped=true&"
import script from "./fullchat.vue?vue&type=script&lang=js&"
export * from "./fullchat.vue?vue&type=script&lang=js&"
import style0 from "./fullchat.vue?vue&type=style&index=0&id=d9295620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9295620",
  null
  
)

export default component.exports